import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./slices";
import { AppVersion } from './utils/version';
import { preventOverscroll } from './utils/preventOverscroll';
import RenderErrorBoundary from './utils/renderErrorBoundary';
import frontendLogger from './utils/frontendLogger';
// Setup API interceptor for logging
import './utils/apiInterceptor';
// Setup performance monitoring
import './utils/performanceLogger';
import './assets/css/page-transitions.css';
import './assets/css/sidebar-scroll-fix.css';
import './assets/css/logo-spinner.css';
// IMPORTANT: This MUST be loaded last to override all other styles
import './dark-mode-override.css';

// Initialize frontend logger
frontendLogger.info('Application starting', {
  version: AppVersion.version,
  environment: process.env.NODE_ENV,
});

// Log version info on app start
AppVersion.logVersion();

// Prevent overscroll/bounce effect
preventOverscroll();

const store = configureStore({ reducer: rootReducer, devTools: true });

// Wait for DOM to be fully loaded before rendering
const renderApp = () => {
  const rootElement = document.getElementById('root');
  
  if (!rootElement) {
    console.error('Root element not found');
    return;
  }
  
  const root = ReactDOM.createRoot(rootElement);
  
  root.render(
    <RenderErrorBoundary>
      <Provider store={store}>
        <React.Fragment>
          <BrowserRouter basename={process.env.PUBLIC_URL}>
            <App />
          </BrowserRouter>
        </React.Fragment>
      </Provider>
    </RenderErrorBoundary>
  );
};

// Ensure DOM is ready before rendering
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', renderApp);
} else {
  // DOM is already loaded
  renderApp();
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();